import { PLAYBACK_RANGE_GEOCODE_DEBOUNCE_MS } from '@/utils/playbackRangeClip'

/**
 * 关联条拖动期间：起终点逆地理防抖（停止拖动后再解析）
 * @param {Vue} vm 轨迹地图组件实例
 * @param {object} firstPoint
 * @param {object} lastPoint
 * @param {(firstPoint: object, lastPoint: object, gen: number) => void|Promise<void>} runGeocode
 */
export function schedulePlaybackRangeEndpointGeocode(vm, firstPoint, lastPoint, runGeocode) {
  if (!vm || !firstPoint || !lastPoint || typeof runGeocode !== 'function') return
  cancelPlaybackRangeEndpointGeocode(vm)
  vm._playbackRangeGeocodePending = { firstPoint, lastPoint }
  vm._playbackRangeGeocodeGen = (vm._playbackRangeGeocodeGen || 0) + 1
  const gen = vm._playbackRangeGeocodeGen
  vm._playbackRangeGeocodeTimer = setTimeout(() => {
    vm._playbackRangeGeocodeTimer = null
    if (gen !== vm._playbackRangeGeocodeGen) return
    const pending = vm._playbackRangeGeocodePending
    if (!pending) return
    runGeocode(pending.firstPoint, pending.lastPoint, gen)
  }, PLAYBACK_RANGE_GEOCODE_DEBOUNCE_MS)
}

/** 取消待执行的关联条起终点逆地理（如重置轨迹、组件销毁） */
export function cancelPlaybackRangeEndpointGeocode(vm) {
  if (!vm) return
  if (vm._playbackRangeGeocodeTimer) {
    clearTimeout(vm._playbackRangeGeocodeTimer)
    vm._playbackRangeGeocodeTimer = null
  }
  vm._playbackRangeGeocodeGen = (vm._playbackRangeGeocodeGen || 0) + 1
  vm._playbackRangeGeocodePending = null
}

export function isPlaybackRangeGeocodeGenerationStale(vm, gen) {
  return gen != null && gen !== vm._playbackRangeGeocodeGen
}
